<template lang="pug">
.v-modal-menu.modal-menu.scrollbar(v-if="data && slotProps.isMenuOpen" )
	.modal-menu__content--bg-left
	.modal-menu__content--bg-right
	.modal-menu__content
		.modal-menu__left(v-if="data.left")
			.modal-menu__left-header(v-if="data.left.header" )
				.modal-menu__logo(
					v-if="data.left.header.image"
					v-html="data.left.header.image")
				.modal-menu__btn-wrap(v-if="isSm" )
					.modal-menu__search(v-if="this.$slots['search']")
						slot(name="search")
					.modal-menu__search(v-if="this.$slots['compare']")
						slot(name="compare")
					.blur-wrap(v-for="(button, index) in data.right.header.buttons" :key="index")
						button.btn.btn--icon.btn--gray(
							:class="button.className"
							@click="handleClick(button?.event)"
							:type="button.type || 'button'")
							.btn__icon(v-if="button.icon")
								v-svg-icon.icon-search(:icon="button.icon")
							| {{ button?.text ? button.text : '' }}
						.blur
			.modal-menu__left-wrap
				.modal-menu__left-main(v-if="data.left.main" )
					.modal-menu__title(v-if="data.left.main.title" ) {{ data.left.main.title }}
					.modal-menu__items(v-if="data.left.main.items")
						.modal-menu__left-main-item(v-for="(item, index) in data.left.main.items" :key="index")
							a.modal-menu__left-item-link.h3(v-if="item.href && item.text" :href="item.href || '#'") {{ item.text }}
				.modal-menu__left-footer(v-if="data.left.footer && !isSm" )
					.modal-menu__footer-items(v-if="data.left.footer.items")
						.modal-menu__footer-item(v-for="(item, index) in data.left.footer.items" :key="index")
							a.modal-menu__footer-item-link(v-if="item.href && item.text" :href="item.href || '#'") {{ item.text }}

		.modal-menu__right(v-if="data.right")
			.modal-menu__right-header(v-if="data.right.header && !isSm")
				.modal-menu__right-header-actions
					button.modal-menu__header-link.btn(v-if="data.right.header.link" @click="showForm")
						.link-inner(v-html="data.right.header.link?.text" )
					.modal-menu__search(v-if="this.$slots['search']")
						slot(name="search")
					.modal-menu__search(v-if="this.$slots['compare']")
						slot(name="compare")
					template(v-for="(button, index) in data.right.header.buttons" :key="index")
						.blur-wrap
							button.btn.btn--icon.btn--gray(
									:class="button.className"
									@click="handleClick(button?.event)"
									:type="button.type || 'button'")
								.btn__icon(v-if="button.icon")
									v-svg-icon.icon-search(:icon="button.icon")
								| {{ button?.text ? button.text : '' }}
							.blur
			.modal-menu__right-wrap
				.modal-menu__right-main(v-if="data.right.main" )
					.modal-menu__title(v-if="data.right.main.title" ) {{ data.right.main.title }}
					.modal-menu__items(v-if="data.right.main.items")
						.modal-menu__right-main-item.flc(v-for="(item, index) in data.right.main.items" :key="index")
							a.modal-menu__right-item-link(v-if="item.href" :href="item.href || '#'")
								.modal-menu__right-item-text(v-if="item.text" ) {{ item.text }}
								img.modal-menu__right-item-image(
										v-if="item.image"
										:src="item.image?.src"
										:alt="item.image?.alt")
				.modal-menu__right-footer(v-if="data.right.footer && !isSm" )
					a.modal-menu__right-footer-link.btn.btn--transparent(
							v-if="data.right.footer.link"
							:href="data.right.footer.link?.href || '#'")
						v-svg-icon.icon-download(:icon="data.right.footer.link?.icon")
						.link-inner(v-html="data.right.footer.link?.text " )
					.modal-menu__right-footer-fields(v-if="data.right.footer.field")
						v-field(v-model="data.right.footer.field.value" :field="data.right.footer.field")
		.modal-menu__mobile(v-if="isSm && data?.left.footer && data?.right.footer && data?.right.header" )
			button.modal-menu__header-link.btn(v-if="data.right.header.link" @click="showForm")
				.link-inner(v-html="data.right.header.link?.text" )
			.modal-menu__left-footer(v-if="data.left.footer" )
				.modal-menu__footer-items(v-if="data.left.footer.items")
					.modal-menu__footer-item(v-for="(item, index) in data.left.footer.items" :key="index")
						a.modal-menu__footer-item-link(v-if="item.href && item.text" :href="item.href || '#'") {{ item.text }}
			.modal-menu__right-footer(v-if="data.right.footer" )
				a.modal-menu__right-footer-link.btn.btn--transparent(
					v-if="data.right.footer.link"
					:href="data.right.footer.link?.href || '#'")
					v-svg-icon.icon-download(:icon="data.right.footer.link?.icon")
					.link-inner(v-html="data.right.footer.link?.text " )
				.modal-menu__right-footer-fields(v-if="data.right.footer.field")
					v-field(v-model="data.right.footer.field.value"  :field="data.right.footer.field")


</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue'
import scrollLock from "scroll-lock";
export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	props: {
		slotProps: {
			type: Object,
			default: {}
		}
		// clicked: {
		// 	type: Function
		// },
		// isMenuOpen: {
		// 	type: Boolean,
		// 	default: false
		// }
	},

	emits: [
		'close-menu'
	],

	data() {
		return {
			data: null,
			asideOpen: false
		};
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},

		handleClick(event) {
			switch (event) {
				case 'close': {
					this.slotProps.clicked()
					break
				}
			}
		},

		showForm() {
			this.slotProps.showForm()
		},
	},
};
</script>
